"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function FiftyThree() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.24,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="featuredfiftythreefoot" data-nav="light" className="bg-background text-foreground py-14 md:py-20 lg:py-24">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="bg-card text-card-foreground border border-border rounded-lg shadow-sm p-6 sm:p-8 md:p-10 lg:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Left Column: Image */}
            <div className="w-full">
              <div className="aspect-[16/11] w-full overflow-hidden rounded-lg border border-border bg-muted shadow-md">
                <img src="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png" data-wvc-srcset="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png-wvc-srcset" data-wvc-sizes="https://fridgefleet.com/wp-content/uploads/2026/09/FF-Reefer-trailer.png-wvc-sizes" alt="Fridge Fleet 53-foot reefer trailer for temporary refrigerated storage" loading="lazy" decoding="async" className="w-full h-full rounded-lg object-cover" style={{
                objectPosition: "30% 40%"
              }} />
              </div>
            </div>

            {/* Right Column: Content */}
            <div className="flex flex-col justify-center">
              <div className="mb-3">
                <Badge variant="outline" className="bg-muted text-muted-foreground border-border text-[11px] font-normal py-0.5 px-2">
                  Specifications pending confirmation
                </Badge>
              </div>

              <h2 className="font-default text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
                53-Foot Reefer Trailer
              </h2>

              <p className="font-sans text-base sm:text-lg text-muted-foreground leading-relaxed mt-4">
                Fridge Fleet offers a 53-foot reefer trailer for large-capacity temporary refrigerated storage needs. Availability, specifications, delivery requirements, intended use, and temperature requirements must be confirmed individually.
              </p>

              <div className="flex gap-4 flex-wrap mt-6">
                <motion.div whileTap={{
                scale: 0.98
              }}>
                  <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold">
                    <Link to="/FootRefrigeratedTrailerRentalsPage">
                      View 53-Foot Reefer Trailer
                    </Link>
                  </Button>
                </motion.div>

                <motion.div whileTap={{
                scale: 0.98
              }}>
                  <Button asChild variant="outline" size="lg">
                    <Link to="/ContactRequestAQuotePage">
                      Request a Quote
                    </Link>
                  </Button>
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}